import { useAppSelector } from "../store/index.ts";

export default function useDecimalValue() {
  const balance = useAppSelector((state) => state.user.balance);

  const getDecimalValue = (val, currency) => {
    const curBalance = balance?.[currency];
    const decimal = curBalance?.info?.decimal;
    return val?.toFixed(decimal || 0);
  };

  return { getDecimalValue };
}
